import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosWOBaseUrl';

export const insertExternalClaims = createAsyncThunk(
  'externalClaims/insert',
  async (claims, { rejectWithValue }) => {
    try {
      const response = await axios.post('/tradepartner/insert-external-claims', claims);
      return response.data; // Result<List<ExternalClaimInsertResult>>
    } catch (err) {
      return rejectWithValue(err.response?.data || { errorMessage: 'Bir hata oluştu' });
    }
  }
);

export const fetchExternalChannels = createAsyncThunk(
  'externalClaims/fetchExternalChannels',
  async () => {
    const resp = await axios.get('/tradepartner/external-channels');
    return resp.data.Data; // [{ Id, ChannelDesc, TenantId }, …]
  }
);

export const fetchExternalStatuses = createAsyncThunk(
  'externalClaims/fetchExternalStatuses',
  async () => {
    const resp = await axios.get('/tradepartner/external-statuses');
    return resp.data.Data;
  }
);

export const fetchExternalClaimDetails = createAsyncThunk(
  'externalClaims/fetchExternalClaimDetails',
  async (_, { rejectWithValue }) => {
    try {
      const resp = await axios.get('/tradepartner/external-claim-detail');
      if (resp.data.Success) {
        return resp.data.Data;
      } else {
        return rejectWithValue(resp.data.ErrorMessage || 'Detaylar yüklenemedi');
      }
    } catch (err) {
      return rejectWithValue(err.response?.data?.ErrorMessage || 'Sunucu hatası');
    }
  }
);

export const checkExternalClaimIds = createAsyncThunk(
  'externalClaims/checkIds',
  async (requestPayload, { rejectWithValue }) => {
    try {
      const response = await axios.post('/tradepartner/check-claims', requestPayload);
      // Beklenen response: { Success: true, Data: [...], ... }
      if (response.data.Success) {
        return response.data.Data;
      } else {
        return rejectWithValue(response.data.ErrorMessage || 'Kontrol işlemi başarısız');
      }
    } catch (err) {
      const message =
        err.response?.data?.ErrorMessage ||
        err.message ||
        'Beklenmeyen bir hata oluştu';
      return rejectWithValue(message);
    }
  }
);

const externalClaimSlice = createSlice({
  name: 'externalClaims',
  initialState: {
    insertResult: null,
    loading: false,
    error: null,  
    
    checkResult: null,         
    checkLoading: false,       
    checkError: null,          


    channels: [],
    channelsLoading: false,
    channelsError: null,

    statuses: [],
    statusesLoading: false,
    statusesError: null,

    details: [],
    detailsLoading: false,
    detailsError: null,
  },
  reducers: {
    resetInsertResult: (state) => {
      state.insertResult = null;
      state.error = null;
      state.loading = false;
    },
     resetCheckResult: (state) => {          
      state.checkResult = null;
      state.checkError = null;
      state.checkLoading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      // insertExternalClaims
      .addCase(insertExternalClaims.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.insertResult = null;
      })
      .addCase(insertExternalClaims.fulfilled, (state, action) => {
        state.loading = false;
        state.insertResult = action.payload;
      })
      .addCase(insertExternalClaims.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.errorMessage || 'Beklenmeyen bir hata oluştu';
      })

      // checkExternalClaimIds
      .addCase(checkExternalClaimIds.pending, (state) => {
        state.checkLoading = true;
        state.checkError = null;
        state.checkResult = null;
      })
      .addCase(checkExternalClaimIds.fulfilled, (state, action) => {
        state.checkLoading = false;
        state.checkResult = action.payload || [];
      })
      .addCase(checkExternalClaimIds.rejected, (state, action) => {
        state.checkLoading = false;
        state.checkError = action.payload || action.error.message;
      })

      // fetchExternalChannels
      .addCase(fetchExternalChannels.pending, (state) => {
        state.channelsLoading = true;
        state.channelsError = null;
      })
      .addCase(fetchExternalChannels.fulfilled, (state, action) => {
        state.channelsLoading = false;
        state.channels = action.payload;
      })
      .addCase(fetchExternalChannels.rejected, (state, action) => {
        state.channelsLoading = false;
        state.channelsError = action.error.message;
      })

      // fetchExternalStatuses
      .addCase(fetchExternalStatuses.pending, (state) => {
        state.statusesLoading = true;
        state.statusesError = null;
      })
      .addCase(fetchExternalStatuses.fulfilled, (state, action) => {
        state.statusesLoading = false;
        state.statuses = action.payload;
      })
      .addCase(fetchExternalStatuses.rejected, (state, action) => {
        state.statusesLoading = false;
        state.statusesError = action.error.message;
      })

      // fetchExternalClaimDetails
      .addCase(fetchExternalClaimDetails.pending, (state) => {
        state.detailsLoading = true;
        state.detailsError = null;
      })
      .addCase(fetchExternalClaimDetails.fulfilled, (state, action) => {
        state.detailsLoading = false;
        state.details = action.payload;
      })
      .addCase(fetchExternalClaimDetails.rejected, (state, action) => {
        state.detailsLoading = false;
        state.detailsError = action.payload || action.error.message;
      })
  },
});

export const {
  resetInsertResult,
  resetCheckResult
} = externalClaimSlice.actions;
export default externalClaimSlice.reducer;
